import React from 'react';

const GlobalCoverage: React.FC = () => {
  const regions: string[] = [
    'North America',
    'South America',
    'Latin America & Caribbean',
    'Europe',
    'Middle East',
    'Africa',
    'Asia Pacific'
  ];

  return (
    <section className="global-coverage">
      <div className="global-coverage-inner">
        <div className="section-label"><span>Global Coverage</span></div>
        <h2 className="section-title">Wherever you're expanding,<br /><em>we have the data.</em></h2>
        <p className="section-sub">We cover 150+ countries with localised salary benchmarks, acquisition costs, tax rates, and competitive data so your simulation reflects the real conditions on the ground in your target market.</p>
        <div className="region-tags-dark">
          {regions.map((region, index) => (
            <span key={index} className="region-tag-dark">{region}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalCoverage;
